module.exports = __webpack_public_path__ + "static/img/xinguan2.80d826d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xinguan2.png
// module id = wXlu
// module chunks = 1